if (typeof window.syncCartHeaderBadge !== 'function') {
  window.syncCartHeaderBadge = function(count) {
    const applyCount = (val) => {
      const num = parseInt(val, 10) || 0;
      document.querySelectorAll('#Cartcount, .cart-count, .cart-drawer__count-badge').forEach(b => {
        b.textContent = num;
      });
      document.querySelectorAll('.wbhcart span:not(#Cartcount):not(.svgbg)').forEach(l => {
        l.innerHTML = num === 1 ? '&nbsp;item' : '&nbsp;items';
      });
    };
    if (typeof count === 'number' || (typeof count === 'string' && count !== '')) {
      applyCount(count);
    } else {
      fetch('/cart.js').then(r => r.json()).then(c => applyCount(c.item_count)).catch(() => {});
    }
  };
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.querySelector('.wbquicksuccess')?.classList.add('hidden'); // Webibazaar Quickview Message
            this.handleErrorMessage(response.description);
          } else {
            // Trigger sleek bottom Toast and update Cart Drawer (both Desktop & Mobile)
            if (window.cartDrawer) {
              window.cartDrawer.showToast(response);
            }
            this.querySelector('.wbquicksuccess')?.classList.remove('hidden'); // Webibazaar Quickview Message
          }

          // Refresh Cart Drawer & Header Cart Badge cleanly once
          if (window.cartDrawer) {
            window.cartDrawer.refresh();
          } else if (typeof window.syncCartHeaderBadge === 'function') {
            window.syncCartHeaderBadge();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
      }

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        // Auto-dismiss after 6 seconds for clean card UX
        this.errorTimeout = setTimeout(() => {
          if (this.errorMessageWrapper) {
            this.errorMessageWrapper.setAttribute('hidden', '');
          }
        }, 6000);
      }
    }
  });
}
